export default __webpack_public_path__ + "media/images/client-logos/veriphy-157aceb513340c1d4fe59c0895cc7881.png";